import { useToast } from 'vuestic-ui'
import Swal from 'sweetalert2/dist/sweetalert2'
import i18n from '@/i18n'

const { t } = i18n.global

function info(msg) {
  toast_show('info', msg)
}

function success(msg, duration) {
  toast_show('success', msg, duration)
}

function warn(msg, duration) {
  toast_show('warning', msg, duration)
}

function error(msg) {
  toast_show('error', msg)
}

function toast_show(icon, msg, duration = 3000) {
  Swal.fire({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: duration,
    timerProgressBar: true,
    icon: icon,
    title: t('toast.system_prompt'),
    text: msg,
  })
}

export default {
  info,
  success,
  warn,
  error,
}


